const Index = () => import('../index.vue');

const Create = () => import(/* webpackChunkName: "employee" */ '../components/Create.vue');
const List = () => import(/* webpackChunkName: "employee" */ '../components/List.vue');
const Edit = () => import(/* webpackChunkName: "employee" */ '../components/Edit.vue');

export default [
  {
    path: 'employee',
    name: 'employee',
    component: Index,
    title: 'employee',
    redirect: { name: 'employee-list' },
    children: [
      {
        path: 'create',
        name: 'employee-create',
        component: Create,
      },
      {
        path: 'list',
        name: 'employee-list',
        component: List,
      },
      {
        path: ':id/edit',
        name: 'employee-edit',
        component: Edit,
      },
    ],
  },
];
